var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7643 22.4388H1.2558C0.924119 22.4388 0.606021 22.5705 0.371486 22.8051C0.136951 23.0396 0.00519052 23.3577 0.00519052 23.6894C0.00519052 24.0211 0.136951 24.3392 0.371486 24.5737C0.606021 24.8082 0.924119 24.94 1.2558 24.94H18.7643C19.096 24.94 19.4141 24.8082 19.6487 24.5737C19.8832 24.3392 20.015 24.0211 20.015 23.6894C20.015 23.3577 19.8832 23.0396 19.6487 22.8051C19.4141 22.5705 19.096 22.4388 18.7643 22.4388Z",
    fill: "#BEBBB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25587 19.9375H1.36842L6.58347 19.4623C7.15474 19.4054 7.68905 19.1537 8.09671 18.7495L19.3522 7.49396C19.7891 7.03244 20.0252 6.41657 20.0087 5.78129C19.9923 5.14602 19.7248 4.54315 19.2647 4.1048L15.838 0.678132C15.3908 0.258047 14.8047 0.0170077 14.1913 0.00086637C13.578 -0.015275 12.9801 0.194608 12.5114 0.590589L1.25587 11.8461C0.851627 12.2537 0.599927 12.788 0.543019 13.3593L0.00525626 18.5744C-0.0115908 18.7575 0.0121775 18.9422 0.0748667 19.1151C0.137556 19.288 0.237622 19.445 0.367933 19.5749C0.48479 19.6908 0.623378 19.7825 0.77575 19.8447C0.928121 19.9069 1.09128 19.9385 1.25587 19.9375ZM14.0996 2.42899L17.5138 5.84315L15.0126 8.28184L11.6609 4.93021L14.0996 2.42899ZM2.9692 13.5719L10.0101 6.58101L13.3868 9.95766L6.38337 16.9611L2.63154 17.3113L2.9692 13.5719Z",
    fill: "#BEBBB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0ffc707e952891af8b575692ded729b1.svg";
export { ForwardRef as ReactComponent };